import { createContext, useContext } from "react";
import PropTypes from "prop-types";
import { find, get } from "lodash";

import GenericValueList from "./helpers/GenericValueList";
import { localizedField } from "../../../shared/multilingualism/localized";

// Don't link selection values by default
// Provide url function via SelectionUrlContext if you want to link them
export function selectionFilterUrl() {
  return null;
}
export const SelectionUrlContext = createContext(selectionFilterUrl);

function MaybeLink({ href, children }) {
  return href ? <a href={href}>{children}</a> : children;
}
MaybeLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node.isRequired,
};

function Selection({ displayValue, property }) {
  const selectionFilterUrl = useContext(SelectionUrlContext);

  // The server renders displayValue in the network locale; when the option
  // definition is available, re-localize its label for the current locale.
  const localizedLabel = (value) => {
    const optionValue = get(value, ["value"]);
    const option =
      optionValue != null &&
      find(get(property, ["options"]), { value: optionValue });
    return option ? localizedField(option, "label") : null;
  };

  return (
    <GenericValueList
      values={displayValue}
      component={(value) => (
        <MaybeLink href={selectionFilterUrl({ ...value, property })}>
          {localizedLabel(value) ||
            get(value, ["displayValue"]) ||
            get(value, ["label"]) ||
            value}
        </MaybeLink>
      )}
    />
  );
}
Selection.propTypes = {
  displayValue: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({ label: PropTypes.string, value: PropTypes.string }),
    ),
    PropTypes.arrayOf(PropTypes.string),
  ]),
  property: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
};

export default Selection;
